import http from '@root/utils/axios/admin';

let state = {
    PaymentsList: [],
    Payment: {
        data: {},
        error: {}
    }
}

let actions = {

    fetchPaymentsList({ commit }, filter = {}) {
        return new Promise((resolve, reject) => {
            http.get('user/payments', { params: filter }).then((response) => {
                commit('setPaymentsList', response.data);
                resolve(response);
            }).catch((errors) => {
                reject(errors);
            })
        })
    },

    deletePayment({ commit }, id) {
        return http.delete('user/payments/' + id);
    },

    fetchPayment({ commit }, id) {
        return new Promise((resolve, reject) => {
            http.get('user/payments/' + id).then((response) => {
                commit('setPayment', response.data.data);
                resolve(response);
            }).catch((errors) => {
                reject(errors);
            })
        })
    },

    CreatePayment({ commit }, data) {
        return new Promise((resolve, reject) => {
            http.post('user/payments', data).then((response) => {
                commit('setPayment', response.data);
                resolve(response);
            }).catch((error) => {
                if (error.response && error.response.status === 422) {
                    commit('setPaymentError', error.response.data);
                }
                reject(error.response);
            })
        });

    },

    updatePayment({ commit }, data) {
        return new Promise((resolve, reject) => {
            http.post('user/payments/' + data.id, data).then((response) => {
                commit('setPayment', response.data);
                resolve(response);
            }).catch((error) => {
                if (error.response && error.response.status === 422) {
                    commit('setPaymentError', error.response.data);
                }
                reject(error.response);
            })
        });
    },



}


let mutations = {
    setPaymentsList(state, data) {
        state.PaymentsList = data;
    },
    setPayment(state, data) {
        state.Payment.data = data;
    },
    setPaymentError(state, error) {

        state.Payment.error = error.errors;
    },
    cleanPaymentError(state, error) {
        state.Payment.error = {};
    },

}

export default {
    state,
    actions,
    mutations
}